/** @format */

import React, {useState, cloneElement, useEffect} from 'react';
import PropTypes from 'prop-types';

export const NarrowTable = props => {
    const {
        rememberExpanded = false,
        defaultExpanded = false,
        className = '',
        isExpandable,
        borderedRows,
        caption = '',
        children,
        columns,
        rows,
        ...restOfProps
    } = props;

    const [isExpanded, setIsExpanded] = useState([]);

    useEffect(() => {
        const expandedRows = defaultExpanded ? rows.map(row => row.key) : [];
        setIsExpanded(expandedRows);
    }, [rows, defaultExpanded, isExpandable]);

    const handleExpandableRow = rowKey => {
        if (isExpanded.includes(rowKey)) {
            setIsExpanded(isExpanded.filter(row => row !== rowKey));
        } else {
            setIsExpanded([...isExpanded, rowKey]);
        }
    };

    return (
        <div className={`${className} narrow-table-common-65gq`} {...restOfProps}>
            <table className="narrow-table-common-65gq__table" cellSpacing={0} width={'100%'}>
                <tbody>
                    {rows.map((row, index) => {
                        // give access to the renderData to the child component for each row
                        const childRowWithData = !children
                            ? children
                            : cloneElement(children, {
                                  ...children.props,
                                  renderData: row.renderData
                              });

                        const rowExpandedClass = isExpanded.includes(row.key)
                            ? 'narrow-table-common-65gq-table_row--expanded'
                            : '';

                        const isEvenRow = index % 2 === 0;

                        const rowClass = isEvenRow ? 'narrow-table-common-65gq__row--even' : '';
                        const iconClass = isExpanded.includes(row.key) ? 'fa-minus' : 'fa-plus';

                        return columns.map((column, columnIndex) => (
                            <React.Fragment key={column.key}>
                                <tr
                                    role="row"
                                    className={`narrow-table-common-65gq__row ${rowClass}`}>
                                    {isExpandable && columnIndex === 0 && (
                                        <td
                                            role="cell"
                                            className={`narrow-table-common-65gq__cell--toggle ${rowExpandedClass}`}
                                            rowSpan={columns.length}>
                                            <button
                                                className="p-0 table-common-65gq-table_expandable-button"
                                                onClick={() => handleExpandableRow(row.key)}>
                                                <i
                                                    className={`fa ${iconClass} color-accent-primary`}
                                                />
                                            </button>
                                        </td>
                                    )}
                                    <th
                                        scope="rowheader"
                                        className="narrow-table-common-65gq__cell--header">
                                        {column.title}
                                    </th>
                                    <td
                                        role="cell"
                                        className="narrow-table-common-65gq__cell--content">
                                        {row[column.key]}
                                    </td>
                                </tr>

                                {/* we only need to append one row at the end*/}
                                {isExpanded.includes(row.key) &&
                                    isExpandable &&
                                    columnIndex === columns.length - 1 && (
                                        <tr className="narrow-table-common-65gq-table_tr--expandable">
                                            <td colSpan={3} className="expandable-65gq_td">
                                                {childRowWithData}
                                            </td>
                                        </tr>
                                    )}
                            </React.Fragment>
                        ));
                    })}
                </tbody>
            </table>
        </div>
    );
};

NarrowTable.propTypes = {
    rememberExpanded: PropTypes.bool,
    defaultExpanded: PropTypes.bool,
    className: PropTypes.string,
    isExpandable: PropTypes.bool,
    borderedRows: PropTypes.bool,
    caption: PropTypes.string,
    children: PropTypes.node,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired
        })
    ).isRequired,
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            renderData: PropTypes.object
        })
    ).isRequired
};
